import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { azul } from '../../assets/js/colors'
import { Btn, InputText } from '../../components'
import { hideLoadingBox, showLoadingBox, showMessageBox } from '../../store/actions/system.actions'

import '../Login/Login.css'
import useForgotPassword, { LOAD_MESSAGE } from './ForgotPasswordHook'

function NewPassword({ history, dispatch }) {
  const { state, localDispatch } = useForgotPassword()

  useEffect(() => {
    localDispatch.onInit(localDispatch.getQueryParams().token)
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.CHANGE_PASSWORD:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.changePassword(
          localDispatch.getQueryParams().token,
          state.userCredentials.senha,
        )
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox('Senha alterada com sucesso', null))
        dispatch(hideLoadingBox())
        history.push('/')
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        localDispatch.resetState()
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div className="Login">
      <div className="form__container">
        <div style={{ textAlign: 'start', fontSize: '24px', color: azul }}>Redefinir senha</div>
        <div className="form">
          <div style={{ textAlign: 'start', marginTop: 15, color: azul }}>
            {' '}
            Insira a nova senha de acesso.{' '}
          </div>
          <InputText
            type="password"
            label="Nova Senha"
            value={state.userCredentials.senha}
            onChange={value => localDispatch.onChange('senha', value)}
          />
          <InputText
            type="password"
            label="Confirma Senha"
            value={state.userCredentials.confirmarSenha}
            onChange={value => localDispatch.onChange('confirmarSenha', value)}
            onEnter={() =>
              localDispatch.onChangePassword(
                state.userCredentials.senha,
                state.userCredentials.confirmarSenha,
              )
            }
          />
          <div className="text-center" style={{ marginTop: 20 }}>
            <Btn
              onClick={() =>
                localDispatch.onChangePassword(
                  state.userCredentials.senha,
                  state.userCredentials.confirmarSenha,
                )
              }
              isLoading={state.isLoading}
            >
              Alterar senha
            </Btn>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect()(NewPassword)
